
import { useEffect, useState } from "react";
import { logger } from "@/lib/logger";

export function useStaffViewMode(specificStaffId?: string) {
  const [isViewingExistingStaff, setIsViewingExistingStaff] = useState(false);
  const [staffId, setStaffId] = useState<string | undefined>(undefined);

  useEffect(() => {
    // Validate the staffId - check if it's a valid UUID
    const isValidUUID = specificStaffId && 
      specificStaffId !== ':staffId' && 
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(specificStaffId);

    if (specificStaffId && isValidUUID) {
      // If we have a valid specific staff ID, we're viewing/managing an existing staff
      setIsViewingExistingStaff(true);
      setStaffId(specificStaffId);
      logger.info(`Viewing existing staff with ID: ${specificStaffId}`);
    } else {
      if (specificStaffId && !isValidUUID) {
        logger.warn(`Invalid staff ID format received: ${specificStaffId}`);
      }
      setIsViewingExistingStaff(false);
      setStaffId(undefined);
      logger.info("Creating a new staff member or viewing staff list");
    }
  }, [specificStaffId]);

  return {
    isViewingExistingStaff,
    staffId
  };
}
